import { Button } from "@caspeco/casper-ui-library";
import { useTranslation } from "react-i18next";
import { QueryKeys } from "../types/query-key-enum";
import queryClient from "../query-client";
import { getClaimValue } from "../utils/general-helper";
import { BffUserData } from "../services/api/user-api";

const LogoutButton = () => {
	const { t } = useTranslation();

	const bffUser = queryClient.getQueryData<BffUserData>([QueryKeys.BffUser]);
	const logoutUrl = getClaimValue(bffUser, "bff:logout_url");

	const handleSignOut = () => {
		window.location.href = logoutUrl!;
	};

	return (
		logoutUrl && (
			<Button onClick={handleSignOut} w="100%">
				{t("choice_logout")}
			</Button>
		)
	);
};

export default LogoutButton;
